export default __webpack_public_path__ + "static/media/banco9.ab214087.jpg";